import React from 'react'

function CircularOpticlean() {
  return (
    <embed src="\pdfs\E1.1.10.2_OC-R_Circular_Opticlean_01.2018-kr.pdf" width="100%" height="2100px" />
  )
}

export default CircularOpticlean